// extracted by mini-css-extract-plugin
module.exports = {"Lead":"Lead_Lead__RRQ__","Lead___lg":"Lead_Lead___lg__HMy9n"};